module.exports = __webpack_public_path__ + "static/media/icon-restore.5334460c.svg";